// tslint:disable completed-docs
export enum DocumentStatus {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',
    EDITABLE = 'EDITABLE',
    DELETED = 'DELETED',
    DELETED_PERMANENTLY = 'DELETED_PERMANENTLY'
}
